import { TicketMetaField } from "../../../administration";
import {
  ClassNameFieldExtensions,
  SelectParseWithClass,
  SelectParseWithoutClass,
} from "../../../administration/ticket_creation/types/field_configs/Meta";

export type TicketMeta = {
  fields: TicketTypedMetaField[];
};

export type TicketMetaFormField = {
  [key: string]: MetaFieldData["value"];
};

export type TicketMetaFieldType = (typeof TicketMetaFieldTypes)[number];

export const TicketMetaFieldTypes = [
  "string",
  "number",
  "boolean",
  "date",
  "select",
  "select_parse",
] as const;

type MetaFieldValueString = {
  type: "string";
  value: string;
};

type MetaFieldValueNumber = {
  type: "number";
  value: number;
};

type MetaFieldValueBoolean = {
  type: "boolean";
  value: boolean;
};

type MetaFieldValueDate = {
  type: "date";
  value: Date;
};

type MetaFieldValueSelect = {
  type: "select";
  value: string;
  multiple: false;
};
type MetaFieldValueSelectMultiple = {
  type: "select";
  value: string[];
  multiple: true;
};

type MetaFieldValueParseSelect = {
  type: "select_parse";
  value: string;
  multiple: false;
};

type MetaFieldValueParseSelectMultiple = {
  type: "select_parse";
  value: string[];
  multiple: true;
};

type MetaFieldData =
  | MetaFieldValueString
  | MetaFieldValueNumber
  | MetaFieldValueBoolean
  | MetaFieldValueDate
  | MetaFieldValueSelect
  | MetaFieldValueSelectMultiple
  | MetaFieldValueParseSelect
  | MetaFieldValueParseSelectMultiple;

type NonSelectParseTyped = {
  [T in Exclude<MetaFieldData["type"], "select_parse">]: Extract<
    TicketMetaField,
    { type: T }
  > &
    Extract<MetaFieldData, { type: T }>;
}[Exclude<MetaFieldData["type"], "select_parse">];

type SelectParseTyped = {
  [K in keyof ClassNameFieldExtensions]: SelectParseWithClass<K>;
}[keyof ClassNameFieldExtensions];

export type TicketTypedMetaField =
  | NonSelectParseTyped
  | SelectParseTyped
  | SelectParseWithoutClass;
